// extracted by mini-css-extract-plugin
export default {"msgM":"cef18697f3"};